<app-header-user></app-header-user>
<!-- Page title -->

<div class="container pt-4 pb-5">
    <div class="row">
      <div class="col-12 mb-4">
        <h2>Acces la documente medicale</h2>
        <p class="mb-0 text-muted">
          Vizualizați și descărcați scrisori medicale, bilete de
          externare, prescripții și alte documente asociate
          investigațiilor și consultațiilor.
        </p>
      </div>
    </div>

<div class="row mb-4">
  <div class="col-12">
    <div class="upload-card dashboard-card">
      <div class="upload-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <div class="upload-icon">
            <i class="bx bx-upload"></i>
          </div>
          <div>
            <h5 class="mb-0">Încarcă un document medical</h5>
            <small class="text-muted">
              Poți încărca bilete de externare, rezultate sau alte documente (PDF, imagini).
            </small>
          </div>
        </div>
      </div>

      <div class="upload-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
           <label for="documentType">Tip document</label>
          <select
            id="documentType"
            [(ngModel)]="upload.documentTypeCode"
            [disabled]="loadingDocumentTypes"
            class="form-control"
          >
            <option value="">
              {{ loadingDocumentTypes ? 'Se încarcă...' : 'Selectează tipul de document' }}
            </option>
            <option *ngFor="let type of documentTypes" [value]="type.code">
              {{ type.label }}
            </option>
          </select>
          </div>
          
          
          <div class="col-md-5">
            <label class="form-label mb-1">Fișier</label>

            <div
              class="upload-dropzone"
              (click)="fileInput.click()"
            >
              <ng-container *ngIf="!upload.file">
                <i class="bx bx-cloud-upload"></i>
                <div>Alege un fișier sau trage-l aici</div>
                <small class="text-muted">Format recomandat: PDF, JPG, PNG. Max 10 MB.</small>
              </ng-container>

              <ng-container *ngIf="upload.file">
                <div class="selected-file-name">
                  {{ upload.file.name }}
                </div>
                <button
                  type="button"
                  class="btn btn-link p-0 text-danger"
                  (click)="clearSelectedFile($event)"
                >
                  Elimină
                </button>
              </ng-container>
            </div>

            <input
              type="file"
              #fileInput
              class="d-none"
              (change)="onFileSelected($event)"
            />
          </div>

          <div class="col-md-3 text-md-end">
            <button
              type="button"
              class="btn btn-success btn-rounded w-100"
              [disabled]="!upload.documentTypeCode || !upload.file || uploading"
              (click)="uploadDocument()"
            >
              <span
                *ngIf="!uploading; else uploadingTpl"
              >
                Încarcă document
              </span>
              <ng-template #uploadingTpl>
                Se încarcă...
              </ng-template>
            </button>
            <small
              class="text-success d-block mt-1"
              *ngIf="uploadSuccessMessage"
            >
              {{ uploadSuccessMessage }}
            </small>
            <small
              class="text-danger d-block mt-1"
              *ngIf="uploadErrorMessage"
            >
              {{ uploadErrorMessage }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


    <!-- Tabs -->
<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
  <div>
    <h4 class="mb-1">Documente și prescripții</h4>
    <p class="mb-0 text-muted">
      Vizualizați și descărcați scrisori medicale, bilete de externare, prescripții și alte documente asociate investigațiilor și consultațiilor.
    </p>
  </div>
</div>

<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === 'EXTERNAL'"
      (click)="setActiveTab('EXTERNAL')"
    >
      Documente și prescripții externe
    </button>
  </li>
  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === 'INTERNAL'"
      (click)="setActiveTab('INTERNAL')"
    >
      Documente și prescripții interne
    </button>
  </li>
</ul>

<div *ngIf="!loading" class="results-table-wrapper">
    <table class="table results-table">
        <thead>
            <tr>
                <th>#</th>
                <th>Tip document</th>
                <th>Nume</th>
                <th>Data</th>
                <th class="text-end">Acțiuni</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="message && (!filteredResults || filteredResults.length === 0)">
                <td colspan="5" class="text-center text-muted">
                    {{ message }}
                </td>
            </tr>

            <tr *ngIf="!message && (!filteredResults || filteredResults.length === 0)">
                <td colspan="5" class="text-center text-muted">
                    {{
                        activeTab === 'EXTERNAL'
                            ? 'Nu ai documente sau prescripții externe înregistrate.'
                            : 'Nu ai documente sau prescripții interne înregistrate.'
                    }}
                </td>
            </tr>

            <tr *ngFor="let result of filteredResults; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ result.documentType?.labels[0]?.label }}</td>
                <td>{{ result.name }}</td>
                <td>{{ result.date | date: "dd.MM.yyyy" }}</td>
                <td class="text-end">
                    <button
                        type="button"
                        class="btn btn-xs btn-outline-primary btn-rounded m-1"
                        (click)="download(result)"
                    >
                        Descarcă
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</div>
